const INACTIVE_INVOICE_STATUSES = new Set([
  "void",
  "voided",
  "canceled",
  "cancelled",
  "failed",
  "inactive",
  "superseded",
]);

const ACTIVE_PAID_INVOICE_STATUSES = new Set([
  "paid",
  "completed",
  "success",
  "succeeded",
]);

export const normalizeInvoiceStatus = (value) =>
  String(value || "").trim().toLowerCase();

export const getInactiveInvoiceReason = (invoice = {}) => {
  const invoiceStatus = normalizeInvoiceStatus(invoice?.invoiceStatus);
  const paymentStatus = normalizeInvoiceStatus(invoice?.paymentStatus);
  const relationships = invoice?.invoiceRelationships;
  const parsedRelationships =
    relationships && typeof relationships === "string"
      ? (() => {
          try {
            return JSON.parse(relationships);
          } catch (_) {
            return {};
          }
        })()
      : (relationships && typeof relationships === "object" ? relationships : {});
  const lifecycle = normalizeInvoiceStatus(
    parsedRelationships?.lifecycle ||
      parsedRelationships?.status ||
      parsedRelationships?.state
  );

  if (invoice?.isActive === false || invoice?.isActive === 0 || invoice?.isActive === "0") {
    if (INACTIVE_INVOICE_STATUSES.has(invoiceStatus)) return invoiceStatus;
    if (INACTIVE_INVOICE_STATUSES.has(paymentStatus)) return paymentStatus;
    if (INACTIVE_INVOICE_STATUSES.has(lifecycle)) return lifecycle;
    // Elite payment flows historically set isActive=false when payment settles.
    // Paid/completed is a financial state, not an inactive invoice lifecycle.
    if (ACTIVE_PAID_INVOICE_STATUSES.has(paymentStatus) || ACTIVE_PAID_INVOICE_STATUSES.has(invoiceStatus)) {
      return null;
    }
    return "inactive";
  }
  if (INACTIVE_INVOICE_STATUSES.has(invoiceStatus)) return invoiceStatus;
  if (INACTIVE_INVOICE_STATUSES.has(paymentStatus)) return paymentStatus;
  if (INACTIVE_INVOICE_STATUSES.has(lifecycle)) return lifecycle;
  return null;
};

export const isInactiveInvoice = (invoice = {}) =>
  Boolean(getInactiveInvoiceReason(invoice));

export const filterActiveInvoices = (invoices = []) =>
  (Array.isArray(invoices) ? invoices : []).filter((invoice) => !isInactiveInvoice(invoice));
